import { formattedMoney, formatSolicitorTableLabel } from '../../../helpers/functions';
import { FormGroup, HorizontalRule, Table } from 'arag-ui-lib';
import { CURRENCY } from '../../../helpers/variables';
import StagesDescription from './stagesDescription';
import CONTENT_STRINGS from '../../../helpers/contentStrings';
import { FORM_GROUP_VARIANTS } from '../../../helpers/formGroupVariants';
import { LOCALE_UK, PALE } from '../../../helpers/constants';
import { getFieldStyles } from '../../../helpers/applicationPremiumSettingsFunctions';

const StagedStep4 = (props) => {
    const {
        stagesSubSettings,
        stagedPremiumData,
        isApplicationPremium,
        amountColumnsDisplayDataPerStage,
        emphasizedFields,
        highlightedFields,
        isStagedApplicationRevisionsModalOpen = false,
        revisionIndex = 0,
        isWizardRun = false,
    } = props;
    
    const notesTestId = isStagedApplicationRevisionsModalOpen ? `staged-premium-notes-history-${revisionIndex}` : 'edit-staged-application-premium-setting-overview-notes';
    const commentsTestId = isStagedApplicationRevisionsModalOpen ? `staged-premium-comments-history-${revisionIndex}` : 'edit-staged-application-premium-setting-overview-comments';
    const coverageTestId = isStagedApplicationRevisionsModalOpen ? `staged-premium-coverage-history-${revisionIndex}` : 'edit-staged-application-premium-setting-overview-coverage';
    const deductiblesTestId = isStagedApplicationRevisionsModalOpen ? `staged-premium-deductible-history-${revisionIndex}` : 'edit-staged-application-premium-setting-overview-deductible';
    const endorsementsTestId = isStagedApplicationRevisionsModalOpen ? `staged-premium-endorsement-history-${revisionIndex}` : 'edit-staged-application-premium-setting-overview-endorsement';
    const averageExpectedPremiumTestId = isStagedApplicationRevisionsModalOpen ? `staged-premium-average-expected-premium-history-${revisionIndex}` : 'edit-staged-application-premium-setting-overview-average-expected-premium';
    const tableTestId = isStagedApplicationRevisionsModalOpen ? `staged-premium-table-history-${revisionIndex}` : 'staged-premium-setting-overview-stages';
    const stageATestId = isStagedApplicationRevisionsModalOpen ? `staged-premium-setting-overview-heading-stage-a-history-${revisionIndex}` : 'staged-premium-setting-overview-heading-stage-a';
    const stageBTestId = isStagedApplicationRevisionsModalOpen ? `staged-premium-setting-overview-heading-stage-b-history-${revisionIndex}` : 'staged-premium-setting-overview-heading-stage-b';
    const stageCTestId = isStagedApplicationRevisionsModalOpen ? `staged-premium-setting-overview-heading-stage-c-history-${revisionIndex}` : 'staged-premium-setting-overview-heading-stage-c';
    
    const stagesColumns = [
        {
            propertyName: 'stageName',
            header: CONTENT_STRINGS.STAGE_OF_POLICY,
            sortable: false,
            id: 'stageName',
            formatter: (v) => {
                return (
                    <FormGroup
                        labelSize={'col-sm-6'}
                        inputSize={'col-sm-6'}
                        label={v.stageName}
                        variant={FORM_GROUP_VARIANTS.PLAIN}
                        inputProps={{
                            id: v.stageName,
                            name: v.stageName,
                        }}
                        formGroupTestId={`staged-premium-setting-overview-heading-stage-${v.stageMachineName}`}
                    />
                );
            },
        },
        {
            propertyName: 'fields',
            header: CONTENT_STRINGS.AMOUNTS,
            sortable: false,
            id: 'fields',
            formatter: (v) => {
                const stageEmphasized = emphasizedFields?.stages?.[v.stageMachineName];
                const stageHighlighted = highlightedFields?.stages?.[v.stageMachineName];
                return amountColumnsDisplayDataPerStage(v).map((c) => {
                    const stage = v.stageMachineName;
                    let formGroupTestId;
                    let fieldKey;
                    if(c.title === CONTENT_STRINGS.PREMIUM){
                        formGroupTestId = `staged-premium-setting-stage-${stage}-premium`;
                        fieldKey = 'premiumAmount';
                    } else if(c.title === CONTENT_STRINGS.LIMIT_OF_INDEMNITY){
                        formGroupTestId = `staged-premium-setting-stage-${stage}-limit-of-indemnity`;
                        fieldKey = 'limitOfIndemnity';
                    } else if(c.title === CONTENT_STRINGS.UNDERWRITER_RATE){
                        formGroupTestId = `staged-premium-setting-stage-${stage}-underwriter-rate`;
                        fieldKey = 'underwriterRatePercentage';
                    }
                    if(v.stagedPremiumSubSettingCommissionDtos.length > 0) {
                        v.stagedPremiumSubSettingCommissionDtos.map((agent, index) => {
                            if(c.title === agent.lawsysName){
                                formGroupTestId = `staged-premium-setting-stage-${stage}-agent-rate-${index}`;
                                fieldKey = `commission_${agent.lawsysId}`;
                            }
                        })
                    }
                    // Always display money at 2dp regardless of the real underlying precision.
                    const formattedValue = formattedMoney(c.value, CURRENCY);
                    // The ARAG provider indicator only shows during an active wizard run - on a live
                    // policy/application it's redundant with applicationPolicyViewHeader.js, and the
                    // combination tables will get their own solicitor-group colouring in a later story.
                    const rowLabel = (c.isCommissionAgent && isWizardRun)
                        ? formatSolicitorTableLabel({ label: c.title, aragProvider: c.aragProvider })
                        : c.title;
                    return (
                        <div key={c.title}>
                            <FormGroup
                                labelSize={'col-sm-6'}
                                inputSize={'col-sm-6'}
                                label={rowLabel}
                                variant={FORM_GROUP_VARIANTS.PLAIN}
                                inputProps={{
                                    id: c.title,
                                    name: c.title,
                                    label: formattedValue,
                                    additionalStyle: fieldKey
                                        ? getFieldStyles(fieldKey, stageEmphasized, stageHighlighted)
                                        : {},
                                }}
                                formGroupTestId={formGroupTestId}
                            />
                            <HorizontalRule variant={PALE} />
                        </div>
                    );
                });
            },
        },
    ];
    const mappedStages = stagesSubSettings != undefined ? stagesSubSettings : [];
    const averageExpectedPremium = formattedMoney(stagedPremiumData?.averageExpectedPremium, CURRENCY)
    return (
        <div>
            {
                isApplicationPremium === false
                ?
                    <>
                        <FormGroup
                            labelSize={"col-sm-4"}
                            inputSize={"col-sm-6"}
                            label={CONTENT_STRINGS.VALID_FROM}
                            variant={FORM_GROUP_VARIANTS.PLAIN}
                            inputProps={{
                                id: 'validFrom',
                                name: 'validFrom',
                                label: stagedPremiumData.validFrom ? new Date(stagedPremiumData.validFrom).toLocaleDateString(LOCALE_UK) : '',
                            }}
                            formGroupTestId={'staged-premium-setting-overview-valid-from'}
                        />
                        <FormGroup
                            labelSize={"col-sm-4"}
                            inputSize={"col-sm-6"}
                            label={CONTENT_STRINGS.VALID_UNTIL}
                            variant={FORM_GROUP_VARIANTS.PLAIN}
                            inputProps={{
                                id: 'validUntil',
                                name: 'validUntil',
                                label: stagedPremiumData.validUntil ? new Date(stagedPremiumData.validUntil).toLocaleDateString(LOCALE_UK) : '',
                            }}
                            formGroupTestId={'staged-premium-setting-overview-valid-to'}
                        />
                    </>
                :
                    null
            }
            <FormGroup
                labelSize={"col-sm-4"}
                inputSize={"col-sm-6"}
                label={CONTENT_STRINGS.NOTES}
                variant={FORM_GROUP_VARIANTS.PLAIN}
                inputProps={{
                    id: 'notes',
                    name: 'notes',
                    label: stagedPremiumData?.notes,
                    additionalStyle: getFieldStyles('notes', emphasizedFields, highlightedFields),
                }}
                formGroupTestId={notesTestId}
            />
            <FormGroup
                labelSize={"col-sm-4"}
                inputSize={"col-sm-6"}
                label={CONTENT_STRINGS.COMMENTS}
                variant={FORM_GROUP_VARIANTS.PLAIN}
                inputProps={{
                    id: 'comments',
                    name: 'comments',
                    label: stagedPremiumData?.comments,
                    additionalStyle: getFieldStyles('comments', emphasizedFields, highlightedFields),
                }}
                formGroupTestId={commentsTestId}
            />
            <FormGroup
                labelSize={"col-sm-4"}
                inputSize={"col-sm-6"}
                label={CONTENT_STRINGS.COVERAGE_TYPES}
                variant={FORM_GROUP_VARIANTS.PLAIN}
                inputProps={{
                    id: 'coverageOptionName',
                    name: 'coverageOptionName',
                    label: stagedPremiumData?.coverageOptionName,
                    additionalStyle: getFieldStyles('displayedCoverageType', emphasizedFields, highlightedFields),
                }}
                formGroupTestId={coverageTestId}
            />
            <FormGroup
                labelSize={"col-sm-4"}
                inputSize={"col-sm-6"}
                label={CONTENT_STRINGS.DEDUCTIBLES}
                variant={FORM_GROUP_VARIANTS.PLAIN}
                inputProps={{
                    id: 'deductibles',
                    name: 'deductibles',
                    label: stagedPremiumData?.deductibleOptionName,
                    additionalStyle: getFieldStyles('displayedDeductible', emphasizedFields, highlightedFields),
                }}
                formGroupTestId={deductiblesTestId}
            />
            <FormGroup
                labelSize={"col-sm-4"}
                inputSize={"col-sm-6"}
                label={CONTENT_STRINGS.ENDORSEMENTS}
                variant={FORM_GROUP_VARIANTS.PLAIN}
                inputProps={{
                    id: 'endorsements',
                    name: 'endorsements',
                    label: stagedPremiumData?.endorsementOptionName,
                    additionalStyle: getFieldStyles('displayedEndorsement', emphasizedFields, highlightedFields),
                }}
                formGroupTestId={endorsementsTestId}
            />
            <FormGroup
                labelSize={"col-sm-4"}
                inputSize={"col-sm-6"}
                label={CONTENT_STRINGS.AVERAGE_EXPECTED_PREMIUM}
                variant={FORM_GROUP_VARIANTS.PLAIN}
                inputProps={{
                    id: 'averageExpectedPremium',
                    name: 'averageExpectedPremium',
                    label: averageExpectedPremium,
                    additionalStyle: getFieldStyles('averageExpectedPremium', emphasizedFields, highlightedFields),
                }}
                formGroupTestId={averageExpectedPremiumTestId}
            />
            <HorizontalRule />
            <div>
                <Table
                    orderAsc={false}
                    striped
                    columns={stagesColumns}
                    data={mappedStages}
                    tableWrapperTestId={tableTestId}
                />
            </div>
            <StagesDescription 
                stageATestId={stageATestId}
                stageBTestId={stageBTestId}
                stageCTestId={stageCTestId}
            />
        </div>
    );
 };

export default StagedStep4;
